import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { NavListItemLink } from '../common/NavListItemLink';
import { SystemSetupConfig } from './SystemSetupConfig';
import { SystemSetupUser } from './SystemSetupUser';
import { SystemSetupInfra } from './SystemSetupInfra';
import { SystemSetupSecurity } from './SystemSetupSecurity';

export const SystemSetup = () => (
  <div className="app-content__main">
    <div className="heading">
      <h1>System Setup</h1>
    </div>
    <div className="columns">
      <div className="col-nav">
        <ul className="nav flex-column">
          <NavListItemLink to="/system/setup/config">
            Configuration
          </NavListItemLink>
          <NavListItemLink to="/system/setup/user">
            Configuration User
          </NavListItemLink>
          <NavListItemLink to="/system/setup/infra">
            Infrastructure
          </NavListItemLink>
          <NavListItemLink to="/system/setup/security">
            Security
          </NavListItemLink>
        </ul>
      </div>
      <div className="col">
        <Routes>
          <Route path="" element={<Navigate to="config" replace />} />
          <Route path="config" element={<SystemSetupConfig />} />
          <Route path="user" element={<SystemSetupUser />} />
          <Route path="infra/*" element={<SystemSetupInfra />} />
          <Route path="security/*" element={<SystemSetupSecurity />} />
        </Routes>
      </div>
    </div>
  </div>
);
